import { Observable } from 'rxjs';

export interface StartDownloadPayload {
  /**
   * Observable frío que resuelve el archivo. Se suscribe recién acá, para que
   * el estado sea el dueño de la suscripción y pueda cancelarla.
   */
  blob$: Observable<Blob>;
  fileName: string;
  title?: string;
  message?: string;
  hint?: string;
}

export class StartDownload {
  static readonly type = '[Download] Start download';
  constructor(readonly payload: StartDownloadPayload) {}
}

export class DownloadSuccessful {
  static readonly type = '[Download] Download successful';
}

export class DownloadFailure {
  static readonly type = '[Download] Download failure';
  constructor(readonly payload: { error: unknown }) {}
}

export class CancelDownload {
  static readonly type = '[Download] Cancel download';
}
